module.exports = "<div class=\"l-wrapper l-wrapper--full-height\">\n\n    <!-- 00-01-00_login -->\n    <login-signin *ngIf=\"loginState == 'login'\" [loginError]=\"loginError\" (loginState)=\"changeState($event)\"  (loginData)=\"sendDataLogin($event)\"></login-signin>\n    <!-- END 00-01-00_login -->\n    <login-recovery *ngIf=\"loginState == 'recovery'\" (loginState)=\"changeState($event)\"></login-recovery>\n    <email-sent  *ngIf=\"loginState == 'emailSent'\" ></email-sent>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/login/templates/main-login.html
// module id = ./src/app/modules/login/templates/main-login.html
// module chunks = main